module.exports = __webpack_public_path__ + "ecoin-blue.png?bd276b4dcc0460fbbbdc5b87b09855c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ecoin-blue.png
// module id = 55
// module chunks = 0